module.exports = __webpack_public_path__ + "static/media/4.88c28c58.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Editor/images/4.svg
// module id = 915
// module chunks = 0